import { DateRange } from 'src/interfaces/common/IdValue';
import { PaginationAndFilter } from 'src/interfaces/common/pagination';
import { BankDetails, BrandsProducts, DocumentDetails, FileModel, ServiceType } from 'src/interfaces/new-channel-partner/channelPartner';
import { Availability, Technician, TechnicianBasicProfile } from 'src/interfaces/new-technician/technician';
import axiosClient from 'src/utils/axios-client';
import { APIConfig } from '../../config';

class TechnicianApi {
  private channelPartnerApiUrl = APIConfig.channelPartnerApiUrl;

  private requestManagementUrl = APIConfig.requestManagementUrl;

  async addNewTechnician(basicProfile: TechnicianBasicProfile):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .post(`${this.channelPartnerApiUrl}technician`, basicProfile)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getTechnicianById(technicianId: string):
  Promise<{ responseData: Technician | any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}technician/${technicianId}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getTechnicianByMobile(mobile: string):
  Promise<{ responseData: Technician | any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}technician/mobile/${mobile}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getTechnicianByEmail(email: string):
  Promise<{ responseData: Technician | any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}technician/email/${email}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async updateBasicDetails(basicProfile: TechnicianBasicProfile, technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}technician/${technicianId}/basicDetails`, basicProfile)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async updateBankDetails(bankDetails: BankDetails, technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}technician/${technicianId}/bankDetails`, bankDetails)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async deleteBrand(brandId: string, technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}technician/${technicianId}/brand/${brandId}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async addBrand(addBrand: BrandsProducts, technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}technician/${technicianId}/brand`, addBrand)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async updateBrand(updateBrand: BrandsProducts, technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}technician/${technicianId}/brand/update`, updateBrand)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async addProfilePhoto(document: FileModel, technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}technician/${technicianId}/profileImage`, document)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async addDocument(document: DocumentDetails, technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}technician/${technicianId}/document`, document)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async deleteDocument(id: string, technicianId: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}technician/${technicianId}/document/${id}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async addServiceAreas(serviceAreas: string[], technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}technician/${technicianId}/serviceAreas`, serviceAreas)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async deleteServiceArea(serviceAreaIds: string, technicianId: string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}technician/${technicianId}/serviceAreas/${serviceAreaIds}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async addService(serviceType: ServiceType, technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .patch(`${this.channelPartnerApiUrl}technician/${technicianId}/service`, serviceType)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async deleteService(serviceTypeId: string, technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .delete(`${this.channelPartnerApiUrl}technician/${technicianId}/service/${serviceTypeId}`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async submitProfile(technicianId : string):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .post(`${this.channelPartnerApiUrl}technician/${technicianId}/submit`)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getTechniciansByPaginationAndFilters(options: PaginationAndFilter):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient
        .post(`${this.channelPartnerApiUrl}technician/getByPaginationAndFilter`, options)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  async getActivityLogsById(id: string):
  Promise<{ responseData: any | any, statusCode: number }> {
    try {
      const res = await axiosClient
        .get(`${this.channelPartnerApiUrl}activityLogs/${id}`)
        .then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // calls GET api to get technician availability slots present in the database
  async getTechnicianAvailabilitySlots(technicianId: string, dates: DateRange):
  Promise<{ responseData: Availability[], statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.requestManagementUrl}requests/calendar/timeSlots/technician/${technicianId}`, { params: dates }).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.data,
        statusCode: error.status
      });
    }
  }

  async updateTechnicianStatus(attributes: any):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const body = {
        ...attributes,
      };

      const res = await axiosClient
        .put(`${this.channelPartnerApiUrl}technician/status`, body)
        .then((response) => response);

      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }
}

export const technicianApi = new TechnicianApi();
